import type { TFunction } from "i18next";
import type { TourStep } from "../TourProvider";
import { queryTourTarget } from "../utils/queryTourTarget";

/**
 * Tour configuration for Messages (/messages)
 */
export const messagesTour = (t: TFunction): TourStep[] => [
  {
    title: t("Tour_Messages_Contacts_Title"),
    description: t("Tour_Messages_Contacts_Description"),
    target: () => queryTourTarget("messages-contacts"),
    placement: "right",
  },
  {
    title: t("Tour_Messages_Thread_Title"),
    description: t("Tour_Messages_Thread_Description"),
    target: () => queryTourTarget("messages-thread"),
    placement: "top",
  },
  {
    title: t("Tour_Messages_Composer_Title"),
    description: t("Tour_Messages_Composer_Description"),
    target: () => queryTourTarget("messages-composer"),
    placement: "top",
  },
];
